const STORAGE_KEY = 'avid-adventures:activeGameCode';

const safeRead = (): string | undefined => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
};

const safeWrite = (value: string): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {}
};

const safeClear = (): void => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {}
};

export const activeGameCode = {
  get: safeRead,
  set: safeWrite,
  clear: safeClear,
};
